import { render, staticRenderFns } from "./brainpower.vue?vue&type=template&id=1332b553&"
import script from "./brainpower.vue?vue&type=script&lang=ts&"
export * from "./brainpower.vue?vue&type=script&lang=ts&"
import style0 from "./brainpower.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports